import React from 'react'

import {
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
} from 'react-router-dom'

interface WithRouterProps {
  location: ReturnType<typeof useLocation>
  navigate: ReturnType<typeof useNavigate>
  params: ReturnType<typeof useParams>
  navigationType: ReturnType<typeof useNavigationType>
}

const withRouterCustom = function <T = any>(
  Component: React.ComponentType<T & WithRouterProps>,
) {
  return (props: T) => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()
    const navigationType = useNavigationType()

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        navigationType={navigationType}
      />
    )
  }
}

export default withRouterCustom
